// DashboardContext.jsx
import React, { createContext, useState, useEffect } from "react";
import { updateProfileApi } from "../api/profile";
import { getDonationDataApi } from "../api/donations";

/**
 * DashboardContext
 *
 * Responsibilities:
 * - fetchDashboardData(apikey?) -> uses provider DONDATA to populate profile & transactions
 * - updateProfile(updatedData) -> calls INDDATACORR to update PAN/address (requires user apikey & icsid)
 * - exposes setProfile for external updates (DonationForm can call this)
 *
 * Notes:
 * - If apikey is not provided to fetchDashboardData, this tries to read it from localStorage.iskcon_auth
 *   (which AuthContext stores after verifyOtp).
 * - Provider base and param names are taken from the PDF you supplied.
 */

export const DashboardContext = createContext();

const PROVIDER_BASE = "https://srv.konsoftech.in/ics/api/ah";

function providerUrl(params) {
  return PROVIDER_BASE + "?" + new URLSearchParams(params).toString();
}

async function callProvider(params) {
  const url = providerUrl(params);
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Network error (${res.status})`);
  const json = await res.json();
  return json;
}

// DONDATA helper

// ...


// INDDATACORR helper (update individual data like address/pan)
// async function callIndDataCorr(apikey, icsid, updates = {}) {
//   if (!apikey) throw new Error("apikey required for INDDATACORR");
//   if (!icsid) throw new Error("icsid required for INDDATACORR");
//   const params = { oper: "INDDATACORR", apikey, icsid, ...updates };
//   const json = await callProvider(params);
//   if (json.status !== "OK") throw new Error(json.message || "INDDATACORR failed");
//   return json.data;
// }

export const DashboardProvider = ({ children }) => {
  const [profile, setProfile] = useState({});
  const [serviceRequests, setServiceRequests] = useState([]);
  const [family, setFamily] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [nityaSevaTransactions, setNityaSevaTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  /**
   * fetchDashboardData
   * - Attempts to get per-user apikey from argument or localStorage
   * - Calls DONDATA and maps provider response into profile & transactions
   *
   * usage:
   *  fetchDashboardData() // will try localStorage for apikey
   *  fetchDashboardData("user_apikey_here")
   */
  
  
  
  
  const fetchDashboardData = async (userApikey = null) => {
  setLoading(true);
  try {
    let apikey = userApikey;
    if (!apikey) {
      const raw = localStorage.getItem("iskcon_auth");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.apikey) apikey = parsed.apikey;
      }
    }
    if (!apikey) {
      setProfile({});
      setTransactions([]);
      setNityaSevaTransactions([]);
      throw new Error("No apikey. Please login.");
    }

    // 🔹 call backend instead of provider directly
    const data = await getDonationDataApi(apikey);

    console.log("data test 1", data);

    if (data.status !== "OK") {
      throw new Error(data.message || "Donation data fetch failed");
    }

    const donors = data.data || [];
    if (donors.length === 0) {
      setProfile({});
      setTransactions([]);
      setNityaSevaTransactions([]);
      return;
    }

    const donor = donors[0];
    console.log("donor", donor);
    // Profile mapping
    const profileData = {
      id: donor.icsid,
      name: donor.legalName || donor.donorName,
      mobile: donor.phone,
      email: donor.email,
      pan: donor.panNo,
      address: donor.addrLine1,
      city: donor.city,
      state: donor.state,
      raw: donor,
      ...donor,
    };
    setProfile(profileData);

    // Transactions mapping
    const donations = donor.donations || [];
    const mappedTxns = donations.map((d, idx) => ({
      id: d.receiptNo || `${profileData.id}_${idx}`,
      date: d.receiptDate,
      status: d.status || "SUCCESS",
      name: donor.legalName,
      amount: d.amount,
      receiptNo: d.receiptNo,
    }));
    setTransactions(mappedTxns);

    // Nitya Seva filter
    const nitya = mappedTxns.filter((t) =>
      (t.scheme || "").toLowerCase().includes("nitya")
    );
    setNityaSevaTransactions(nitya);

  } catch (error) {
    console.error("fetchDashboardData error:", error.message);
  } finally {
    setLoading(false);
  }
};

  
  
  
  
  
  // const fetchDashboardData = async (userApikey = null) => {
  //   setLoading(true);
  //   try {
  //     // prefer explicit param; else attempt to read from localStorage (AuthContext saves this)
  //     let apikey = userApikey;
  //     if (!apikey) {
  //       try {
  //         const raw = localStorage.getItem("iskcon_auth");
  //         if (raw) {
  //           const parsed = JSON.parse(raw);
  //           if (parsed && parsed.apikey) {
  //             // check expiry if provided
  //             if (!parsed.apikeyExpiry || Date.now() <= parsed.apikeyExpiry) {
  //               apikey = parsed.apikey;
  //             } else {
  //               console.warn("Saved apikey expired.");
  //             }
  //           }
  //         }
  //       } catch (e) {
  //         console.warn("Failed to read iskcon_auth from localStorage", e);
  //       }
  //     }

  //     if (!apikey) {
  //       throw new Error("No user apikey available. Please login (verify OTP) first.");
  //     }

  //     const donors = await fetchDondata(apikey);

  //     if (!Array.isArray(donors) || donors.length === 0) {
  //       // No donor records found for this apikey
  //       setProfile(null);
  //       setTransactions([]);
  //       setNityaSevaTransactions([]);
  //       setLoading(false);
  //       return;
  //     }

  //     // pick donor record — ideally there will be a single donor for the apikey
  //     // but if multiple returned, try to choose the one matching mobile from localStorage user or fallback to first
  //     let donor = donors[0];
  //     try {
  //       const rawAuth = localStorage.getItem("iskcon_auth");
  //       if (rawAuth) {
  //         const parsedAuth = JSON.parse(rawAuth);
  //         if (parsedAuth && parsedAuth.mobile) {
  //           const match = donors.find((d) => {
  //             const p = (d.donorContact || d.phone || d.contact || "").toString();
  //             return p && parsedAuth.mobile && (p === parsedAuth.mobile.toString() || p.endsWith(parsedAuth.mobile.toString()));
  //           });
  //           if (match) donor = match;
  //         }
  //       }
  //     } catch (e) {
  //       // ignore mapping error
  //     }

  //     // Map donor -> profile
  //     const profileData = {
  //       id: donor.icsid || donor.id || null,
  //       name: donor.legalName || donor.donorName || donor.name || "",
  //       email: donor.email || donor.donorEmail || "",
  //       mobile: donor.phone || donor.donorContact || donor.contact || "",
  //       pan: donor.panNo || donor.donorPAN || "",
  //       address: [donor.addrLine1, donor.addrLine2].filter(Boolean).join(", ") || donor.donorAddress || "",
  //       city: donor.city || "",
  //       state: donor.state || "",
  //       pin: donor.pincode || donor.pin || "",
  //       raw: donor, // keep raw provider object for debugging
  //     };
  //     setProfile(profileData);

  //     // Map donor.donations -> transactions
  //     const donations = Array.isArray(donor.donations) ? donor.donations : [];

  //     const mappedTxns = donations.map((d, idx) => {
  //       const id = d.rno || d.rbno || d.receiptNo || `${profileData.id || "donor"}_${idx}`;
  //       return {
  //         id,
  //         date: d.receiptDate || d.instrumentDate || d.date || null,
  //         type: "Donation",
  //         amount: Number(d.amount || d.amt || 0),
  //         scheme: d.scheme || d.purpose || d.schemeName || "",
  //         mode: (d.mode || "").toUpperCase(),
  //         receiptNo: d.rbno || d.rno || "",
  //         instrumentNo: d.intrumentNo || d.instrumentNo || d.txnId || "",
  //         bankName: d.bankName || "",
  //         taxBenefit: !!d.taxBenefit,
  //         raw: d,
  //       };
  //     });

  //     setTransactions(mappedTxns);

  //     // derive nityaSevaTransactions by heuristic (scheme contains 'nitya' or 'daily' — adjust if you have exact marker)
  //     const nitya = mappedTxns.filter((t) => {
  //       const s = (t.scheme || "").toLowerCase();
  //       return s.includes("nitya") || s.includes("daily") || s.includes("nitya seva") || s.includes("nitya-seva");
  //     });
  //     setNityaSevaTransactions(nitya);

  //     // family/serviceRequests are not provided by DONDATA in doc — keep existing local values
  //   } catch (error) {
  //     console.error("Dashboard data fetch error:", error.message || error);
  //     // Keep previous state in case of failure
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  /**
   * updateProfile
   * - Updates address/pan via INDDATACORR (which requires apikey & icsid)
   * - updatedData must contain icsid (or we try to read from profile.id)
   * - supported fields (based on doc): a1,a2,a3,... or dedicated names: city, state, pin, pan, addrLine1 etc.
   *
   * Example:
   *  updateProfile({ icsid: '154703', city: 'Pune', state: 'Maharashtra', pin: '411001', pan: 'ABCDE1234F' })
   */
     

// ...

const updateProfile = async (updatedData) => {
  setLoading(true);
  try {
    // get apikey from localStorage

    console.log("updateProfile",updatedData);
    let rawAuth = null;
    try {
      rawAuth = JSON.parse(localStorage.getItem("iskcon_auth") || "{}");
    } catch (e) {
      rawAuth = {};
    }
    const apikey = rawAuth?.apikey;
    if (!apikey) throw new Error("User apikey missing. Please login (verify OTP).");

    const icsid = updatedData.icsid || profile?.id;
    if (!icsid) throw new Error("icsid missing (cannot update)");

    // build payload for backend
    const payload = {
      apikey,
      icsid,
      a1: updatedData.a1 || "",
      a2: updatedData.a2 || "",
      a3: updatedData.a3 || "",
      city: updatedData.city || "",
      state: updatedData.state || "",
      ctry: "India", // default if not in form
      pin: updatedData.pincode || "",
      pan: updatedData.pan || "",
    };

    const res = await updateProfileApi(payload);

    if (res.status === "OK") {
      await fetchDashboardData(apikey); // refresh profile from provider
      return { ok: true, data: res };
    } else {
      return { ok: false, message: res.message || "Profile update failed" };
    }
  } catch (err) {
    return { ok: false, message: err.message || "Update failed" };
  } finally {
    setLoading(false);
  }
};


  // Service Request CRUD (kept as-is from your earlier code)
  const addServiceRequest = async (newRequest) => {
    try {
      const response = await fetch(`https://example.com/api/service-requests`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newRequest),
      });

      if (!response.ok) throw new Error("Failed to add service request");

      const createdRequest = await response.json();
      setServiceRequests((prev) => [...prev, createdRequest]);
      return true;
    } catch (error) {
      console.error("Add service request error:", error);
      return false;
    }
  };

  const updateServiceRequest = async (id, updatedData) => {
    try {
      const response = await fetch(`https://example.com/api/service-requests/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) throw new Error("Failed to update service request");

      const updatedRequest = await response.json();
      setServiceRequests((prev) => prev.map((req) => (req.id === id ? updatedRequest : req)));
      return true;
    } catch (error) {
      console.error("Update service request error:", error);
      return false;
    }
  };

  const deleteServiceRequest = async (id) => {
    try {
      const response = await fetch(`https://example.com/api/service-requests/${id}`, {
        method: "DELETE",
      });

      if (!response.ok) throw new Error("Failed to delete service request");

      setServiceRequests((prev) => prev.filter((req) => req.id !== id));
      return true;
    } catch (error) {
      console.error("Delete service request error:", error);
      return false;
    }
  };

  // Family CRUD
  const addRelative = (newRelative) => {
    setFamily((prev) => [...prev, { id: Date.now(), ...newRelative }]);
  };

  const updateRelative = (id, updatedData) => {
    setFamily((prev) => prev.map((rel) => (rel.id === id ? { ...rel, ...updatedData } : rel)));
  };

  const deleteRelative = (id) => {
    setFamily((prev) => prev.filter((rel) => rel.id !== id));
  };

  // Dummy data for development / fallback (keeps your original behavior)
  useEffect(() => {
    // const dummyProfile = {
    //   id: 1,
    //   name: "Saurabh Shelar",
    //   email: "saurabhshelar514@gmail.com",
    //   mobile: "9930294912",
    //   pan: "ABCDE1234F",
    //   street: "MG Road",
    //   area: "Camp",
    //   address: "Flat 201, Sunshine Apartments",
    //   city: "Pune",
    //   state: "Maharashtra",
    //   pin: "411001",
    //   relatives: [
    //     { name: "Rohit Shelar", relation: "Brother", dob: "1995-08-10", ma: "Yes" },
    //     { name: "Anita Shelar", relation: "Mother", dob: "1970-04-15", ma: "No" },
    //   ],
    // };

    // Only set dummy if no real profile exists
    // setProfile((prev) => prev || dummyProfile);
    // setFamily((prev) => (prev && prev.length ? prev : dummyProfile.relatives));
    setServiceRequests((prev) => (prev && prev.length ? prev : [
      // {
      //   id: 1,
      //   requestedBy: "Saurabh Shelar",
      //   service: "Dog Walking",
      //   address: "MG Road, Pune",
      //   createdOn: "2025-09-10",
      //   status: "Pending",
      // },
    ]));
    // setTransactions((prev) => (prev && prev.length ? prev : [
    //   {
    //     id: 1,
    //     date: "2025-08-01",
    //     type: "Donation",
    //     amount: 500,
    //     receiptNo: "TXN12345",
    //   },
    //   {
    //     id: 2,
    //     date: "2025-08-15",
    //     type: "Membership",
    //     amount: 1200,
    //     receiptNo: "TXN67890",
    //   },
    // ]));
    // setNityaSevaTransactions((prev) => (prev && prev.length ? prev : [
    //   {
    //     id: 1,
    //     purpose: "Daily Seva Donation",
    //     date: "2025-07-20",
    //     status: "SUCCESS",
    //     name: "Saurabh Shelar",
    //     amount: 2100,
    //     receiptNo: "NITYA001",
    //   },
    // ]));
  }, []);

  return (
    <DashboardContext.Provider
      value={{
        profile,
        setProfile, // exposed so DonationForm or other components can update profile directly
        serviceRequests,
        family,
        transactions,
        nityaSevaTransactions,
        loading,
        fetchDashboardData,
        updateProfile,
        addServiceRequest,
        updateServiceRequest,
        deleteServiceRequest,
        addRelative,
        updateRelative,
        deleteRelative,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};
